///////// IMPORTS ////////
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";  // ✅ Import for navigation
import UploadImage from "./UploadImage";
import UploadExel from "./UploadExel";
import ProcessButton from "./ProcessButton";
import PostProcessPreview from "./PostProcessPreview";
import TimeStepSelector from "./TimeStepSelector";
import LoadingElement from "./LoadingElement";
import ProcessDataButton2 from "./ProcessDataButton2";

///////// global_parameters /////////
const pixelWidth = 500; // Define pixel width for all elements

function SelectPage() {
  ///////// global_variables /////////
  const navigate = useNavigate(); // ✅ Initialize navigation
  const [imageFile, setImageFile] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [dropdownSelections, setDropdownSelections] = useState({
    timestamp: "none",
    positionID: "none",
    unitID: "none",
  });
  const [nodeData, setNodeData] = useState(null);
  const [unitIDData, setUnitIDData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoadingElement, setShowLoadingElement] = useState(false);

  const [deltaT, setDeltaT] = useState(null);
  const [stepSize, setStepSize] = useState(null);
  const [dataUnit, setDataUnit] = useState(null);
  const [data_json, setDataJson] = useState(null);  // ✅ Store API response
  const [deltaTUnit, setDeltaTUnit] = useState("");
  const [stepSizeUnit, setStepSizeUnit] = useState("");

  // ✅ Handle updates from TimeStepSelector
  const handleTimeStepChange = ({ deltaT, stepSize, deltaTUnit, stepSizeUnit }) => {
    setDeltaT(deltaT);
    setStepSize(stepSize);
    setDeltaTUnit(deltaTUnit);
    setStepSizeUnit(stepSizeUnit);
  };

  const handleUnitChange = (unit) => {
    console.log("[DEBUG] Received unit in SelectPage:", unit);
    setDataUnit(unit);
  };

  useEffect(() => {
    if (data_json && data_json.message === "JSON stored successfully") {
      console.log("[DEBUG] JSON stored successfully, navigating to Site2...");
      navigate("/site2");  // ✅ Redirect immediately
    }
  }, [data_json, navigate]);

  useEffect(() => {
    if (isLoading) {
      setShowLoadingElement(true);
    } else if (!isLoading && showLoadingElement) {
      const timeout = setTimeout(() => setShowLoadingElement(false), 3500);
      return () => clearTimeout(timeout);
    }
  }, [isLoading, showLoadingElement]);

  ///////// HTML/return /////////
  return (
    <div style={styles.container}>
      {showLoadingElement ? (
        <LoadingElement width={pixelWidth} onComplete={() => console.log("Loading Complete")} />
      ) : nodeData && unitIDData ? (
        <>
          <PostProcessPreview width={pixelWidth} filename={excelFile?.name} imageFile={imageFile} />
          <div style={{ height: pixelWidth / 30 }}></div>
          <TimeStepSelector width={pixelWidth} dataUnit={dataUnit} onValuesChange={handleTimeStepChange} />
          <div style={{ height: pixelWidth / 30 }}></div>

          <ProcessDataButton2
            width={pixelWidth}
            deltaT={deltaT}
            stepSize={stepSize}
            deltaTUnit={deltaTUnit}
            stepSizeUnit={stepSizeUnit}
            nodeData={nodeData}
            unitIDData={unitIDData}
            setLoading={setIsLoading}
            dataUnit={dataUnit}
            onDataUpdate={setDataJson}  // ✅ Save JSON and trigger navigation
          />
        </>
      ) : (
        <>
          <UploadImage width={pixelWidth} onFileSelect={setImageFile} />
          <div style={{ height: pixelWidth / 10 }}></div>
          <UploadExel width={pixelWidth} onFileSelect={setExcelFile} onSelectionsChange={setDropdownSelections} onUnitChange={handleUnitChange} />
          <ProcessButton width={pixelWidth} excelFile={excelFile} imageFile={imageFile} dropdownSelections={dropdownSelections}
            onDataUpdate={(node, unit) => { setNodeData(node); setUnitIDData(unit); }}
            setLoading={setIsLoading}
          />
        </>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#343434", // Set background to gray
    padding: "20px",
  },
  infoText: {
    marginTop: "10px",
    fontSize: "14px",
    color: "#fff", //  White text for visibility
    fontWeight: "bold",
  },
};

export default SelectPage;
